module.exports = __webpack_public_path__ + "static/media/message-illustration.805721df.svg";